import SectionHero from "./section-hero";
import SectionHeroConsultingFeatures from "./section-hero-consulting-features";
import SectionHeroOperatingArea from "./section-hero-operating-area";
import SectionHeroProgressStep from "./section-hero-progress-step";
import SectionHeroBusinessValues from "./section-hero-business-values";
import SectionHeroPartners from "./section-hero-partners";
import SectionServices from "./section-services";
import SectionFinalCTA from "./section-final-cta";

const HomePage = () => {
  return (
    <>
      {/* <Header /> */}
      <SectionHero />
      <SectionHeroConsultingFeatures />
      <SectionServices />
      {/* <SectionHeroOperatingArea /> */}
      {/* <SectionHeroProgressStep /> */}
      <SectionHeroBusinessValues />
      <SectionFinalCTA />
      {/* <SectionHeroPartners /> */}
      {/* <Footer /> */}
    </>
  );
};

export default HomePage;
